(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Dato", [], factory);
	else if(typeof exports === 'object')
		exports["Dato"] = factory();
	else
		root["Dato"] = factory();
})(window, function() {
return 